<template>
  <svg
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="44"
      cy="44"
      r="41"
      fill="#4F88BD"
      stroke="#375D82"
      stroke-width="6"
    />
    <path
      d="M67.2959 44C67.2959 55.6969 64.4282 66.1416 59.9493 73.5625C55.436 81.0405 49.614 85 43.7397 85C37.8654 85 32.0434 81.0405 27.5301 73.5625C23.0511 66.1416 20.1835 55.6969 20.1835 44C20.1835 32.3031 23.0511 21.8584 27.5301 14.4375C32.0434 6.95955 37.8654 3 43.7397 3C49.614 3 55.436 6.95955 59.9493 14.4375C64.4282 21.8584 67.2959 32.3031 67.2959 44Z"
      stroke="#375D82"
      stroke-width="6"
    />
    <line y1="43.3432" x2="88" y2="43.3432" stroke="#375D82" stroke-width="6" />
    <line x1="9" y1="23" x2="79.02" y2="23" stroke="#375D82" stroke-width="6" />
    <line
      x1="5.72791"
      y1="63.1302"
      x2="81.7516"
      y2="63.1302"
      stroke="#375D82"
      stroke-width="6"
    />
    <line
      x1="42.3018"
      y1="85.9171"
      x2="42.3018"
      y2="1.56212"
      stroke="#375D82"
      stroke-width="6"
    />
  </svg>
</template>

<script>
export default {
  name: "WebIcon"
};
</script>
